import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DISPLAY_NAMES_DEFAULT = { free: 'Free', standard: 'Core', premium: 'Pass Faster' };

export const useFeatures = () => {
  const { user } = useAuth();
  const [features, setFeatures] = useState(null);
  const [pricing, setPricing] = useState({ free: 0, standard: 4.99, premium: 9.99, one_time: 7.99 });
  const [tiers, setTiers] = useState(null);
  const [displayNames, setDisplayNames] = useState(DISPLAY_NAMES_DEFAULT);
  const [oneTimeAccess, setOneTimeAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFeatures = useCallback(async () => {
    if (!user) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/features`, { withCredentials: true });
      setFeatures(data.current);
      setPricing(data.pricing);
      setTiers(data.tiers);
      setDisplayNames(data.display_names || DISPLAY_NAMES_DEFAULT);
      setOneTimeAccess(data.one_time_access || null);
    } catch (error) {
      console.error('Failed to fetch features:', error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchFeatures();
  }, [fetchFeatures]);

  const hasFeature = (feature) => {
    if (!features) return true; // Loading state, don't block
    return features[feature] === true;
  };

  const canAccessCategory = (categoryId) => {
    if (!features) return true;
    if (features.all_categories) return true;
    return (features.categories || []).includes(categoryId);
  };

  const tier = features?.tier || user?.subscription_tier || 'free';

  return { features, pricing, tiers, loading, tier, displayNames, oneTimeAccess, hasFeature, canAccessCategory, refetch: fetchFeatures };
};
